import {useMutation} from '@tanstack/react-query';
import campaignUpdaters from '@/api/updaters/campaign';

/**
 * Bulk-message the creators contracted on a campaign. Sending messages does not
 * move creators between status buckets or change the roster, so there is no
 * query to invalidate on success (mirrors `useBulkThreads`).
 */
function useBulkCreateMessages() {
  return useMutation({
    mutationKey: ['campaigns', 'bulkCreateMessages'],
    mutationFn: campaignUpdaters.bulkCreateMessages,
  });
}

export default useBulkCreateMessages;
